import { LDContext, LDMultiKindContext } from 'launchdarkly-js-client-sdk';

export interface StoreContextParams {
  storeDealerId: number | string;
  companyDealerId: number | string;
}

export interface CustomerContextParams {
  custSorId: number | string;
  applicationId?: number | string;
  applicationNumber?: string;
}

export function buildLDMultiContext(store: StoreContextParams, customer?: CustomerContextParams): LDMultiKindContext {
  const context: LDMultiKindContext = {
    kind: 'multi',
    store: {
      key: `store-${store.storeDealerId}`,
      storeDealerId: store.storeDealerId,
      companyDealerId: store.companyDealerId,
    },
    company: {
      key: `company-${store.companyDealerId}`,
    },
  };

  if (customer) {
    context.customer = {
      key: `customer-${customer.custSorId}`,
      ...(customer.applicationId !== undefined && { applicationId: customer.applicationId }),
      ...(customer.applicationNumber !== undefined && { applicationNumber: customer.applicationNumber }),
    };
  }

  return context;
}

export function updateCustomerInMultiContext(existingContext: LDContext, customer: CustomerContextParams): LDMultiKindContext {
  const multiCtx = existingContext as LDMultiKindContext;

  return {
    ...multiCtx,
    kind: 'multi',
    customer: {
      key: `customer-${customer.custSorId}`,
      ...(customer.applicationId !== undefined && { applicationId: customer.applicationId }),
      ...(customer.applicationNumber !== undefined && { applicationNumber: customer.applicationNumber }),
    },
  };
}
